import InputBox from "./input-box";

export default InputBox;
